import type { LensDefinition } from '../models/explorer/ExplorerLens';
import {
  iconForCategory,
  resolveCategoryForNode,
} from './providerIcons';

/**
 * P1.4a — GCP icon lens. Same shape as the AWS/Azure lenses against
 * the GCP service → category map.
 */
export const gcpIconLens: LensDefinition = {
  id: 'gcp-icons',
  label: 'GCP icons',
  description: 'Provider-icon view — colours resources by GCP service category.',

  decorate(node) {
    const props = (node.props ?? {}) as Record<string, unknown>;
    const manifestId =
      (props._manifestId as string | undefined) ??
      (props.manifestId as string | undefined) ??
      node.type;
    const category = resolveCategoryForNode('gcp', manifestId);
    if (!category) {
      return {
        dataMissing: true,
        badge: { label: 'unknown service', tone: 'neutral' },
      };
    }
    return {
      icon: iconForCategory(category),
      badge: { label: category, tone: 'neutral' },
    };
  },
};
